import { useMemo } from "react";

import type { WhatsNewSourceI } from "@/modules/whats-new/data/use-whats-new-cards";
import type { WhatsNewAudienceT } from "@/modules/whats-new/lib/types";

import { useFetchTopTen } from "../data/queries";
import { resolveTopTenWhatsNewSource } from "./resolve";

export const useTopTenWhatsNewCards = (
  audience: WhatsNewAudienceT | null
): WhatsNewSourceI => {
  const { data, isPending, isError } = useFetchTopTen(!!audience);

  return useMemo(
    () => resolveTopTenWhatsNewSource(audience, data, isPending && !isError),
    [audience, data, isPending, isError]
  );
};
